import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5476705b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rectChartFont" }
const _hoisted_2 = { class: "chartname" }
const _hoisted_3 = { class: "score-layout" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upline" }, null, -1))
const _hoisted_5 = { class: "score" }
const _hoisted_6 = { class: "score1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score2" }, "/", -1))
const _hoisted_8 = { class: "score3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "program-score" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "得分"),
  /*#__PURE__*/_createElementVNode("div", { class: "p2" }, "标准分")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downline" }, null, -1))
const _hoisted_11 = { class: "information" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-cycle" }, "进度：", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-font" }, "查看详情", -1))
const _hoisted_14 = { class: "chartname" }
const _hoisted_15 = { class: "score-layout-dialog" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upline" }, null, -1))
const _hoisted_17 = {
  class: "content",
  style: {"cursor":"auto"}
}
const _hoisted_18 = { class: "score" }
const _hoisted_19 = { class: "score1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score2" }, "/", -1))
const _hoisted_21 = { class: "score3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "program-score" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "得分"),
  /*#__PURE__*/_createElementVNode("div", { class: "p2" }, "标准分")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downline" }, null, -1))
const _hoisted_24 = { class: "subject-items-content" }
const _hoisted_25 = { class: "subject-items" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "progressBarAll" }
const _hoisted_28 = { class: "progressBarBackground" }
const _hoisted_29 = { class: "subject-items-score" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"1%","line-height":"calc(28 / 1080 * 100vh)","font-size":"14px","font-family":"PingFang SC-Regular, PingFang SC","color":"#18FEFE"} }, " 分", -1))

import { onMounted, ref, toRefs, watch } from 'vue'
import { useRouter } from 'vue-router';
import gauge from "@/components/gauge.vue";
import { scrollbarEmits } from 'element-plus';
import myDialog from '@/views/entryDetailsPages/myDialog.vue'
import javaapi from '@/service/javaapi';

export default /*#__PURE__*/_defineComponent({
  __name: 'chart',
  props: {
    organizationName: {
        type: String,
        default: ''
    },
    checkup_subject_id: {
        type: Number,
        default: 0
    },
    score: {
        type: Number,
        default: 0
    },
    standard_score: {
        type: Number,
        default: 0
    },
    chartname: {
        type: String,
        default: ''
    },
    completed_percentage: {
        type: Number,
        default: 0
    }


},
  setup(__props) {

const props = __props;


const router = useRouter()
const currentHeight = ref(550 / 1080 * window.innerHeight)
window.addEventListener('resize', () => {
    currentHeight.value = 550 / 1080 * window.innerHeight
})

const dialogVisible = ref(false)
const clickButton = async (itemId = 0) => {
    router.push({
        name: 'EntryPages',
        query: {
            checkupSubjectId: checkup_subject_id.value,
            organizationName: organizationName.value,
            checkup_subject_name: chartname.value,
            checkup_subject_item_id: itemId,
        }
    });
}
const { checkup_subject_id, organizationName, chartname } = toRefs(props)

const subjectItems = ref([{
    checkup_subject_item_id: 0,
    checkup_item_name: 111111,
    checkup_item_evaluation_actual_score: 10,
    checkup_item_basic_score: 15,
},
])
// 获取项目
const getItemScore = async () => {
    // console.log("点击了获取得分");
    const query = {
        size: 9999,
        entity: 'subjectItem',
        interface: 'getItemsInfo',
    }
    const selector = {
        checkup_subject_id: checkup_subject_id.value,
        token: localStorage.getItem('token'),
        user_id: localStorage.getItem('user_id')
    }   
    let result = await javaapi.list(query, selector)
    // console.log('result', result)
    subjectItems.value.length = 0
    result.subjectItemDTOes.map((subjectItemDTO) => {
        if (subjectItems.value.filter(subjectItem => { return subjectItemDTO.checkup_item_name === subjectItem.checkup_item_name }).length === 0) {
            // console.log("新添加",subjectItemDTO);
            subjectItems.value.push({ ...subjectItemDTO })
        } else {
            //    console.log("修改已有数据",subjectItemDTO);
            const index = subjectItems.value.findIndex(subjectItem => { return subjectItemDTO.checkup_item_name === subjectItem.checkup_item_name })
            subjectItems.value[index].checkup_item_basic_score += subjectItemDTO.checkup_item_basic_score
            subjectItems.value[index].checkup_item_evaluation_actual_score += subjectItemDTO.checkup_item_evaluation_actual_score
        }
    })
    // subjectItems.value = [...result.subjectItemDTOes]


    
    dialogVisible.value = true;
}


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(chartname)), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_el_tooltip, {
        content: "点击查看得分情况",
        effect: "customized"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "content",
            onClick: getItemScore
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(__props.score), 1),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(__props.standard_score), 1)
            ]),
            _hoisted_9
          ])
        ]),
        _: 1
      }),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode(_component_el_progress, {
        class: "progress",
        percentage: __props.completed_percentage
      }, null, 8, ["percentage"])
    ]),
    _createElementVNode("div", {
      class: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (clickButton()))
    }, [
      _createVNode(_component_el_button, { class: "el-button" }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _createVNode(myDialog, {
      class: "scoreDialog",
      "dialog-visible": dialogVisible.value,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(chartname)), 1),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(__props.score), 1),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, _toDisplayString(__props.standard_score), 1)
            ]),
            _hoisted_22
          ]),
          _hoisted_23
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_el_scrollbar, { height: currentHeight.value }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectItems.value, (subject) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_el_tooltip, {
                    content: "点击跳转至项目材料页",
                    placement: "left-start",
                    effect: "customized"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "subject-items-name",
                        onClick: ($event: any) => (clickButton(subject.checkup_subject_item_id))
                      }, _toDisplayString(subject.checkup_item_name), 9, _hoisted_26)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", {
                        class: "progressBar",
                        style: _normalizeStyle('width:' + ((subject.checkup_item_basic_score === 0) ? 0 : (subject.checkup_item_evaluation_actual_score / subject.checkup_item_basic_score)) * 100 + '%;')
                      }, null, 4)
                    ]),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(subject.checkup_item_evaluation_actual_score) + "/" + _toDisplayString(subject.checkup_item_basic_score), 1),
                    _hoisted_30
                  ])
                ]))
              }), 256))
            ]),
            _: 1
          }, 8, ["height"])
        ])
      ]),
      _: 1
    }, 8, ["dialog-visible"])
  ]))
}
}

})